import {
    BellRing,
    CalendarPlus,
    ClipboardList,
    Eye,
    Pencil,
    Sparkles,
    Trash2,
} from "lucide-react";

export default function CalendarContextMenu({ menu, onAction, onClose }) {
    if (!menu) return null;

    const style = {
        position: "fixed",
        top: menu.y,
        left: menu.x,
        zIndex: 9999,
    };

    const Item = ({ icon: Icon, label, action, danger }) => (
        <button
            type="button"
            onClick={() => {
                onAction(action, menu);
                onClose();
            }}
            className={`w-full flex items-center gap-2 px-3 py-2 text-left text-xs transition ${
                danger
                    ? "text-rose-300 hover:bg-rose-500/15"
                    : "text-[#1a2744] hover:bg-[#c9a961]/15"
            }`}
        >
            <Icon className="h-3.5 w-3.5 shrink-0 opacity-70" />
            {label}
        </button>
    );

    return (
        <>
            <button
                type="button"
                className="fixed inset-0 z-[9998] cursor-default"
                onClick={onClose}
                aria-label="Menüyü kapat"
            />
            <div
                style={style}
                className="z-[9999] min-w-[200px] rounded-lg border border-[#c9a961]/40 bg-[#faf6ee] shadow-2xl py-1 overflow-hidden"
                onContextMenu={(e) => e.preventDefault()}
            >
                <div className="px-3 py-1.5 border-b border-[#c9a961]/20 text-[10px] uppercase tracking-wider text-[#8b7355] font-semibold">
                    {menu.type === "day" ? "Gün işlemleri" : "Etkinlik"}
                </div>
                {menu.type === "day" && (
                    <>
                        <Item icon={CalendarPlus} label="Randevu ekle" action="add-randevu" />
                        <Item icon={BellRing} label="Hatırlatma ekle" action="add-hatirlatma" />
                        <Item icon={Sparkles} label="Etkinlik ekle" action="add-etkinlik" />
                        <Item icon={Eye} label="Gün görünümü" action="view-day" />
                        <Item icon={ClipboardList} label="Ajanda listesi" action="view-agenda" />
                    </>
                )}
                {menu.type === "event" && menu.event && (
                    <>
                        <Item icon={Eye} label="Detay göster" action="view-event" />
                        {menu.event.source !== "takvim" || true ? (
                            <Item icon={Pencil} label="Düzenle" action="edit-event" />
                        ) : null}
                        <Item icon={Trash2} label="Sil" action="delete-event" danger />
                    </>
                )}
            </div>
        </>
    );
}
